import { PolymorphicComponentPropWithRef } from "@omni/types/components/utils/polymorphic.types";
import React from "react";

export type TBodyComponentProps = {};

export type TBodyProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, TBodyComponentProps, "tbody">;

const TBody = <T extends React.ElementType = "tbody">({
    ref,
    className,
    tag,
    innerRef: _innerRef,
    children,
    ...attributes
}: TBodyProps<T>) => {
    const Tag = tag || ("tbody" as React.ElementType);

    const table = (
        <Tag
            {...attributes}
            ref={ref}
            className={className}
        >
            {children}
        </Tag>
    );

    return table;
};

export { TBody };
